import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import '@/assets/vantImp'

import { Button, Table,TableColumn,Form,FormItem,Input,Loading } from 'element-ui'


Vue.use(Input);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Button);
Vue.use(Loading);

// 将 axios 绑定到 Vue 原型上，方便全局使用
Vue.prototype.$axios = axios

// 配置 axios 默认的根路径
axios.defaults.baseURL = process.env.VUE_APP_API_URL

// 可以在此处配置请求头、超时等
axios.defaults.headers.common['Authorization'] = 'eyJhbGciOiJIUzI1NiJ9.eyJhY2NvdW50SW5mbyI6IntcImNyZWF0ZU9yZ0lkXCI6XCIxMDAwMDFcIixcImNyZWF0ZU9yZ05hbWVcIjpcIuaguee7hOe7h1wiLFwiY3VycmVudE9yZ0lkXCI6XCIxMDAwMDFcIixcImZvcmJpZFZpc2l0UGF0aHNcIjpbXSxcImlkXCI6XCIxMDMyNTkwNTQ0Mzg1MDgxMzQ0XCIsXCJsb2dpbk5hbWVcIjpcIkFETUlOXCIsXCJsb2dpblB3ZFR4dFwiOlwiZmMxNzA5ZDBhOTVhNmJlMzBiYzU5MjZmZGI3ZjIyZjRcIixcIm5hbWVcIjpcInN0cmluZ1wiLFwic2Vzc2lvbklkXCI6XCIxMDYzMDEwOTI0MTY1NTk1MTM2XCIsXCJ0ZW5hbnRJZFwiOlwiREVGQVVMVFwifSIsImp0aSI6Ill6VmhOemczWXpFdE56azVNQzAwTXpnNUxXSmhZVFl0TjJRellUZzFPR1EwT0dKaSIsImV4cCI6MTc0Njg3MDEyN30.RVgEkdqjZe1uSuWao-y2XYb7aF8wrRhfiGq4J8VxTdo';
axios.defaults.timeout = 20000

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

// 添加请求拦截器
axios.interceptors.request.use(config => {
  // 在请求发送之前做一些事情，比如添加 token
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, error => {
  // 处理请求错误
  return Promise.reject(error)
})

// 添加响应拦截器
axios.interceptors.response.use(response => {
  // 对响应数据做处理
  const res = response.data;
  return Promise.resolve(res);
}, error => {
  // 处理响应错误
  if (error.response) {
    // 根据响应状态码进行错误处理
    switch (error.response.status) {
      case 401:
        console.error('Unauthorized access, redirecting to login')
        // 可以在此处跳转到登录页或其他处理逻辑
        break
      case 404:
        console.error('Resource not found')
        break
      default:
        console.error('An unexpected error occurred')
    }
  } else {
    console.error('Network error, please try again later')
  }
  return Promise.reject(error)
})
